/* Ground Central — open the cart drawer on add-to-cart.

   The GC sections (best-sellers, collection grid, main product) use plain
   {% form 'product' %} markup rather than Dawn's <product-form> custom element,
   so by default they do a full page POST and land on /cart. This intercepts
   those submits, adds via the Cart AJAX API, and hands the rendered sections to
   Dawn's <cart-drawer> so it refreshes and slides open.

   Dawn's own <product-form> elements are left alone — they already do this. */
(function () {
  if (window.gcCartDrawerReady) return;
  window.gcCartDrawerReady = true;

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('form[action*="/cart/add"]')) return;

    // Dawn's own component handles these.
    if (form.closest('product-form')) return;

    var drawer = getDrawer();
    // No drawer on the page (cart type is page/notification) — let it submit.
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('gc-is-loading');
    }

    function release() {
      if (!button) return;
      button.removeAttribute('aria-disabled');
      button.classList.remove('gc-is-loading');
    }

    var body = new FormData(form);
    body.append(
      'sections',
      drawer.getSectionsToRender().map(function (section) { return section.id; }).join(',')
    );
    body.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) { return response.json(); })
      .then(function (result) {
        // A `status` field means Shopify rejected the add (sold out, limit...).
        // Fall back to a real submit so the shopper sees the actual message.
        if (result.status) {
          release();
          form.submit();
          return;
        }

        // The `is-empty` class is printed by Liquid onto <cart-drawer> itself,
        // which sits OUTSIDE the #CartDrawer block that renderContents swaps,
        // so it never clears on its own. Left behind, Dawn's CSS keeps hiding
        // the header and the line items (`.is-empty .cart__contents`) and keeps
        // .drawer__inner centred — the drawer looks broken on the first add to
        // an empty cart. Dawn's own product-form.js clears it for the same
        // reason; we have to do it too.
        drawer.classList.remove('is-empty');

        if (typeof drawer.setActiveElement === 'function' && button) {
          drawer.setActiveElement(button);
        }
        drawer.renderContents(result);
        release();
      })
      .catch(function () {
        release();
        form.submit();
      });
  });
})();
